var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-12"},[(!_vm.loading)?_c('v-container',[_c('Form',{attrs:{"form":_vm.d.form}}),_c('v-btn',{staticClass:"submit-btn mt-8",attrs:{"color":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }